import Moment from 'moment';

const IMMINENT_INTERVAL = 10 * 60; // 10 Minutes

/**
 * Determine difference between two moments in time
 * @param to Unix Timestamp (seconds) or Date String
 * @param from Unix Timestamp (seconds) or Date String
 * @param units 'seconds', 'days' etc.
 * @returns {number}
 */
export function difference(to, from, units) {
  const toMoment = Number.isInteger(to) ? Moment.unix(to) : Moment(to);
  const fromMoment = Number.isInteger(from) ? Moment.unix(from) : Moment(from);
  return toMoment.diff(fromMoment, units);
}

/**
 * Determine whether the provided moment in time is close enough to the present to be considered imminent
 * @param time Unix Timestamp (seconds) or Date String
 * @returns {boolean}
 */
export function isImminent(time, interval = IMMINENT_INTERVAL) {
  const diff = difference(time, Math.floor(Date.now() / 1000), 'seconds');
  return diff > 0 && diff < interval;
}

/**
 * Determine whether the provided moment in time is already passed to be considered ended
 * @param time Unix Timestamp (seconds) or Date String
 * @returns {boolean}
 */
export function isEnded(time) {
  const diff = difference(time, Math.floor(Date.now() / 1000), 'seconds');
  return diff < 0;
}
